import React, { FC } from 'react';
import { Screen } from '../../../theme';
import { Modal } from '../../ui';
import { BackButton, NewButton } from '../Button';
import { FlexContainer } from '../Container';
import { ButtonContainer } from './style';

interface ConfirmProps {
  children?: React.ReactNode;
  close: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  title?: string;
  confirmText?: string;
  cancelText?: string;
  hideHeading?: boolean;
  maxWidth?: Screen;
  isLoading?: boolean;
}

const Confirm: FC<ConfirmProps> = ({
  children,
  close,
  onConfirm,
  isOpen,
  title,
  confirmText,
  cancelText,
  hideHeading,
  maxWidth,
  isLoading = false,
}) => {
  return (
    <Modal maxWidth={maxWidth} title={title} hideHeading={hideHeading} isOpen={isOpen} close={close} hideCloseButton>
      <FlexContainer flexDirection="column" gap="xs" padLeft={true}>
        {children}
        <ButtonContainer>
          <BackButton title={cancelText} onClick={close} enabled={!isLoading} />
          <NewButton title={confirmText} onClick={onConfirm} isWorking={isLoading} enabled={!isLoading} />
        </ButtonContainer>
      </FlexContainer>
    </Modal>
  );
};

Confirm.defaultProps = {
  confirmText: 'Delete',
  cancelText: 'Cancel',
  title: 'Do you really want to delete this item?',
};

export default Confirm;
